export default {
  'pages.applicationCenter.card.free': '無料',
  'pages.applicationCenter.card.paid': '有料',
  'pages.applicationCenter.card.perSeat': '席数に応じた料金',
  'pages.applicationCenter.card.pricePending': '料金を確認中',
  'pages.applicationCenter.card.developerUnknown': '開発者情報なし',
  'pages.applicationCenter.card.noDescription':
    'アプリの概要はありません。詳細をご確認ください。',
  'pages.applicationCenter.card.official': '公式認証済み',
  'pages.applicationCenter.card.installed': '利用開始済み',
};
